import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Layout from '../components/Layout';
import PortfolioData from '../data/portfolio/PortfolioData.json';

const PortfolioDetail = () => {
  const { id } = useParams();
  const item = PortfolioData.find((p) => p.id === parseInt(id));

  if (!item) {
    return (
      <Layout>
        <div className="container section">
          <h1>Portfolio item not found</h1>
          <Link to="/photography">← Back to Photography</Link>
        </div>
      </Layout>
    );
  }

  // Fix image paths - remove ./ prefix to work with public folder
  const imageSrc = (item.largeImage || item.image).replace('./', '/');

  return (
    <Layout>
      <div className="section">
        <div className="container" style={{ maxWidth: '800px' }}>
          <Link to="/photography" style={{ marginBottom: '2rem', display: 'inline-block' }}>
            ← Back to Photography
          </Link>

          <h1>{item.title}</h1>
          <p className="text-light">
            {item.client} • {item.date}
          </p>

          <img
            src={imageSrc}
            alt={item.title}
            style={{ width: '100%', marginTop: '2rem', marginBottom: '2rem', borderRadius: '8px' }}
          />

          {item.body && item.body.map((paragraph, index) => (
            <div key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default PortfolioDetail;
